type Props = {
  title: string;
  subtitle?: string;
  endpoint?: { method: string; path: string };
  actions?: React.ReactNode;
};

const methodColor: Record<string, string> = {
  GET: "bg-sky-100 text-sky-800",
  POST: "bg-brand-100 text-brand-800",
  PUT: "bg-amber-100 text-amber-800",
  DELETE: "bg-rose-100 text-rose-800",
};

export function PageHeader({ title, subtitle, endpoint, actions }: Props) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-3 border-b border-ink-200 pb-4">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-xl font-semibold text-ink-900">{title}</h1>
          {endpoint && (
            <span className="inline-flex items-center gap-2 rounded-md border border-ink-200 bg-white px-2 py-0.5 text-xs">
              <span
                className={`rounded px-1.5 py-0.5 text-[10px] font-bold tracking-wider ${
                  methodColor[endpoint.method] ?? "bg-ink-200 text-ink-800"
                }`}
              >
                {endpoint.method}
              </span>
              <code className="ks-code text-ink-700">{endpoint.path}</code>
            </span>
          )}
        </div>
        {subtitle && <p className="mt-1 max-w-2xl text-sm text-ink-600">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
